<template>
  <div class="caoZongCeShiKanban">
    <h1 style="text-align: center; margin-top: 0vh; line-height: 8vh;">操纵测试区域看板</h1>
    <div style="background-color: #2D4054; margin: 2vh 1vh 0vh 1vh;">
      <div style="width: 66%; float: left;">
        <div style="margin: 1vh 0 0 1%;">
          <div v-show="ifShow" style="width: 30%; float: left; margin-left: 3%;">
            <div class="timeText" style="float: left;">本年</div>
            <div
                ref="numberGrow1"
                style="float: left;"
                :data-time="time"
                class="number-grow"
                :data-value="year">
              0
            </div>
            <div class="clear"/>
          </div>
          <div style="width: 30%; float: left; margin-left: 3%;">
            <span class="timeText" style="float: left;">本月</span>
            <span
                ref="numberGrow2"
                style="float: left;"
                :data-time="time"
                class="number-grow"
                :data-value="month">0</span>
            <div class="clear"/>
          </div>
          <div style="width: 30%; float: left; margin-left: 3%;">
            <span class="timeText" style="float: left;">本日</span>
            <span
                ref="numberGrow3"
                style="float: left;"
                :data-time="time"
                class="number-grow"
                :data-value="day">0</span>
            <div class="clear"/>
          </div>
          <div class="clear"/>
        </div>
        <div>
          <div style="font-size: 3vh; float: left; margin: 3vh 0 0 1vh; position: absolute; z-index: 999;">* 调试</div>
          <div class="chart1" style="width: 47%; height: 30vh; float: left; margin-left: 6%;"/>
          <div class="chart2" style="width: 47%; height: 30vh; float: left;"/>
          <div class="clear"/>
        </div>
      </div>
      <div style="width: 34%; float: right;">
        <el-table :data="PartDTS" height="37vh" size="medium" style="font-size: 2.6vh;">
          <el-table-column prop="factoryNum" label="PC号" :width="fontSize(1.8)"/>
          <el-table-column prop="materialDescription" label="柜型"/>
        </el-table>
      </div>
      <div class="clear"/>
    </div>
    <div style="margin: 2vh 1vh 0vh 1vh;">
      <div style="font-size: 3vh; float: left; margin: 1vh 0 0 1vh;">* 人员测试数量</div>
      <el-table :data="OutputNumList" height="42vh" size="medium" style="font-size: 2.4vh">
        <el-table-column prop="scanMenName" label="姓名"/>
        <el-table-column prop="f9" label="9:00"/>
        <el-table-column prop="f10" label="10:00"/>
        <el-table-column prop="f11" label="11:00"/>
        <el-table-column prop="f12" label="12:00"/>
        <el-table-column prop="f13" label="13:00"/>
        <el-table-column prop="f14" label="14:00"/>
        <el-table-column prop="f15" label="15:00"/>
        <el-table-column prop="f16" label="16:00"/>
        <el-table-column prop="f17" label="17:00"/>
        <el-table-column prop="f18" label="18:00"/>
        <el-table-column prop="f19" label="19:00"/>
        <el-table-column prop="f20" label="20:00"/>
      </el-table>
    </div>
  </div>
</template>

<script>
  import "echarts-liquidfill";
  export default {
    data() {
      return {
        ifShow: new Date().toDateString() !== "Thu Sep 10 2020",
        date: new Date().getTime(),
        time: 2,
        year: 0,
        month: 0,
        day: 0,
        myChart1: null,
        myChart2: null,
        lastDayPlanNum: 0,
        lastDayNum: 0,
        todayPlanNum: 0,
        todayNum: 0,
        PartDTS: [],
        OutputNumList: [],
      };
    },
    mounted() {
      this.getPartTSSLList();
      this.getPartDTSList();
      this.getTestPersonnelOutputNumList();
      this.myChart1 = this.$echarts.init(document.querySelector(".chart1"));
      this.myChart2 = this.$echarts.init(document.querySelector(".chart2"));
      setInterval(() => {
        this.getPartTSSLList();
        this.getPartDTSList();
        this.getTestPersonnelOutputNumList();
        this.date = new Date().getTime();
      }, 1000 * 60 * 0.2);
      setInterval(() => {
        this.PartDTS.push(this.PartDTS[0]);
        this.PartDTS.splice(0, 1);
      }, 4000);
    },
    methods: {
      getPartTSSLList() {
        let params = {
          date: this.date,
          strType: "操纵箱",
        };
        this.$http.get("basic","kanban/getPartTSSLList", params).then(res => {
          for(let item of res) {
            if(item.name === "本年调试数量") {
              this.year = (item.bl === null ? 0 : item.bl);
            } else if(item.name === "本月调试数量") {
              this.month = (item.bl === null ? 0 : item.bl);
            } else if(item.name === "本日调试数量") {
              this.day = (item.bl === null ? 0 : item.bl);
            } else if(item.name === "前一天调试计划数量") {
              this.lastDayPlanNum = (item.bl === null ? 0 : item.bl);
            } else if(item.name === "前一天调试完成数量") {
              this.lastDayNum = (item.bl === null ? 0 : item.bl);
            } else if(item.name === "当天调试计划数量") {
              this.todayPlanNum = (item.bl === null ? 0 : item.bl);
            } else if(item.name === "当天调试完成数量") {
              this.todayNum = (item.bl === null ? 0 : item.bl);
            }
          }
          this.$nextTick(() => {
            this.numberGrow(this.$refs.numberGrow1);
            this.numberGrow(this.$refs.numberGrow2);
            this.numberGrow(this.$refs.numberGrow3);
            this.refreshChart();
          });
        });
      },
      getPartDTSList() {
        let params = {
          date: this.date,
          strType: "操纵箱",
        };
        this.$http.get("basic","kanban/getPartDTSList", params).then(res => {
          this.PartDTS = res;
        });
      },
      getTestPersonnelOutputNumList() {
        let params = {
          date: this.date,
          strType: "操纵箱",
        };
        this.$http.get("basic","kanban/getTestPersonnelOutputNumList", params).then(res => {
          this.OutputNumList = res;
        });
      },
      refreshChart() {
        let option1 = {
          backgroundColor: "#2D4054",
          title: {
            text: "\n\n\n昨天\n调试\n数量",
            left: "left",
            textStyle: {
              fontWeight: "normal",
              fontSize: this.fontSize(0.2),
              color: "RGB(255,255,255)",
              lineHeight: this.fontSize(0.25),
            },
          },
          series: [{
            type: "liquidFill",
            radius: "80%",
            data: [this.lastDayNum/this.lastDayPlanNum, this.lastDayNum/this.lastDayPlanNum],
            backgroundStyle: {
              borderWidth: this.fontSize(0.05),
              borderColor: "RGB(60,204,214)",
              color: "RGB(63,97,119)",
            },
            label: {
              normal: {
                // formatter: ((this.lastDayNum/this.lastDayPlanNum) * 100).toFixed(2) + "%",
                formatter: this.lastDayNum + "\n\n总: " + this.lastDayPlanNum,
                textStyle: {
                  fontSize: this.fontSize(0.3),
                  color: "#fff",
                  fontWeight: "bold",
                },
              },
            },
            outline: {
              borderDistance: 0,
              itemStyle: {
                borderWidth: this.fontSize(0.05),
                borderColor: "RGB(68,130,216)",
              },
            },
          }],
        };
        this.myChart1.setOption(option1);

        let option2 = {
          backgroundColor: "#2D4054",
          title: {
            text: "\n\n\n当天\n调试\n数量",
            textStyle: {
              fontWeight: "normal",
              fontSize: this.fontSize(0.2),
              color: "RGB(255,255,255)",
              lineHeight: this.fontSize(0.25),
            },
          },
          series: [{
            type: "liquidFill",
            radius: "80%",
            data: [this.todayNum/this.todayPlanNum, this.todayNum/this.todayPlanNum],
            backgroundStyle: {
              borderWidth: this.fontSize(0.05),
              borderColor: "RGB(60,204,214)",
              color: "RGB(63,97,119)",
            },
            label: {
              normal: {
                // formatter: ((this.todayNum/this.todayPlanNum) * 100).toFixed(2) + "%",
                formatter: this.todayNum + "\n\n总: " + this.todayPlanNum,
                textStyle: {
                  fontSize: this.fontSize(0.3),
                  color: "#fff",
                  fontWeight: "bold",
                },
              },
            },
            outline: {
              borderDistance: 0,
              itemStyle: {
                borderWidth: this.fontSize(0.05),
                borderColor: "RGB(68,130,216)",
              },
            },
          }],
        };
        this.myChart2.setOption(option2);
      },
      numberGrow(ele) {
        if (ele.dataset.value < 40) {
          ele.innerHTML = ele.dataset.value;
          return;
        }
        let step = Math.floor((ele.dataset.value * 5) / (ele.dataset.time * 100));
        let current = 0;
        let start = 0;
        let t = setInterval(function() {
          start += step;
          if (start > ele.dataset.value) {
            clearInterval(t);
            start = ele.dataset.value;
            t = null;
          }
          if (current === start) {
            return;
          }
          current = start;
          ele.innerHTML = current.toString().replace(/(\d)(?=(?:\d{3}[+]?)+$)/g, "$1,");
        }, 10);
      },
      fontSize(res) {
        let clientWidth = window.innerWidth||document.documentElement.clientWidth||document.body.clientWidth;
        if (!clientWidth) return;
        let fontSize = 100 * (clientWidth / 1920);
        return res*fontSize;
      },
    },
  };
</script>

<style lang="scss">
  .caoZongCeShiKanban {
    width: 100%;
    height: 100vh;
    margin: 0 auto;
    background: url("/img/kanban_bg.png") no-repeat;
    background-size: 100% 100%;
    position: relative;
    text-align: center;
    color: #ffffff;
    .el-table, .el-table__expanded-cell, .el-table th, .el-table tr{
      background-color: transparent!important;
      color: #fff;
    }
    ::-webkit-scrollbar{
      width: 0.2vh;
    }
    ::-webkit-scrollbar-thumb{
      border-radius: 0.2vh;
      height: 5vh;
      background: #eee;
    }
    ::-webkit-scrollbar-track{
      box-shadow: inset 0 0 5vh rgba(0, 0, 0, 0.2);
      border-radius: 0.2vh;
      background: rgba(0,0,0,0.4);
    }
    .el-table__body tr:hover>td{
      background-color: #263445!important;
    }
    .el-table__body tr.current-row>td{
      background-color: #263445!important;
    }
    .el-table__header-wrapper th:nth-last-of-type(2){
      border-right: none;
    }
    .el-table--border td:nth-last-of-type(1){
      border-right: none;
    }
    .clear{
      clear:both
    }
    .number-grow {
      font-family: Arial-BoldMT;
      font-size: 7vh;
      color: #81C3FF;
      letter-spacing: 0.267vh;
      line-height: 7vh;
      margin-left: 3%;
    }
    .timeText {
      font-family: Arial-BoldMT;
      font-size: 4vh;
      line-height: 7vh;
      color: #fff;
    }
  }
</style>
